/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntryTender } from './EntryTender';
import {
    EntryTenderFromJSON,
    EntryTenderFromJSONTyped,
    EntryTenderToJSON,
    EntryTenderToJSONTyped,
} from './EntryTender';
import type { CompetitionFeeStructure } from './CompetitionFeeStructure';
import {
    CompetitionFeeStructureFromJSON,
    CompetitionFeeStructureFromJSONTyped,
    CompetitionFeeStructureToJSON,
    CompetitionFeeStructureToJSONTyped,
} from './CompetitionFeeStructure';
import type { FuelPricingMode } from './FuelPricingMode';
import {
    FuelPricingModeFromJSON,
    FuelPricingModeFromJSONTyped,
    FuelPricingModeToJSON,
    FuelPricingModeToJSONTyped,
} from './FuelPricingMode';
import type { EscrowCurrency } from './EscrowCurrency';
import {
    EscrowCurrencyFromJSON,
    EscrowCurrencyFromJSONTyped,
    EscrowCurrencyToJSON,
    EscrowCurrencyToJSONTyped,
} from './EscrowCurrency';
import type { TokenEntryConfigResponse } from './TokenEntryConfigResponse';
import {
    TokenEntryConfigResponseFromJSON,
    TokenEntryConfigResponseFromJSONTyped,
    TokenEntryConfigResponseToJSON,
    TokenEntryConfigResponseToJSONTyped,
} from './TokenEntryConfigResponse';

/**
 * Entry fee configuration as returned in API responses. No `required:` array and no `minimum:` constraints — historical / legacy records may have missing fields or zero-value entries that the request schema's create-time guards would reject.
 * @export
 * @interface EntryFeeConfigResponse
 */
export interface EntryFeeConfigResponse {
    /**
     * Entry fee amount. The unit depends on which competition type owns the row, and the two do not agree. Challenges and tournaments store USD as cents (500 = $5.00) and FUEL as base units. Leaderboards store USD as whole dollars (1 = $1.00) and FUEL as base units. Read the owning type before doing arithmetic on this field. When fuelPricingMode is USD_EQUIVALENT the amount is denominated in USD even though feeCurrency is FUEL — the entrant pays FUEL converted at join time.
     * 
     * @type {number}
     * @memberof EntryFeeConfigResponse
     */
    entryFee?: number;
    /**
     * 
     * @type {EscrowCurrency}
     * @memberof EntryFeeConfigResponse
     */
    feeCurrency?: EscrowCurrency;
    /**
     * Platform fee percentage (0-100)
     * @type {number}
     * @memberof EntryFeeConfigResponse
     */
    platformFeePercent?: number;
    /**
     * 
     * @type {CompetitionFeeStructure}
     * @memberof EntryFeeConfigResponse
     */
    feeStructure?: CompetitionFeeStructure;
    /**
     * 
     * @type {FuelPricingMode}
     * @memberof EntryFeeConfigResponse
     */
    fuelPricingMode?: FuelPricingMode;
    /**
     * 
     * @type {number}
     * @memberof EntryFeeConfigResponse
     */
    minEntryFee?: number;
    /**
     * 
     * @type {number}
     * @memberof EntryFeeConfigResponse
     */
    maxEntryFee?: number;
    /**
     * Which tenders the competition accepts. Absent or empty reads as Fuel only.
     * @type {Array<EntryTender>}
     * @memberof EntryFeeConfigResponse
     */
    permittedTenders?: Array<EntryTender>;
    /**
     * 
     * @type {TokenEntryConfigResponse}
     * @memberof EntryFeeConfigResponse
     */
    tokenEntryConfig?: TokenEntryConfigResponse;
}



/**
 * Check if a given object implements the EntryFeeConfigResponse interface.
 */
export function instanceOfEntryFeeConfigResponse(value: object): value is EntryFeeConfigResponse {
    return true;
}

export function EntryFeeConfigResponseFromJSON(json: any): EntryFeeConfigResponse {
    return EntryFeeConfigResponseFromJSONTyped(json, false);
}

export function EntryFeeConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryFeeConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'feeCurrency': json['feeCurrency'] == null ? undefined : EscrowCurrencyFromJSON(json['feeCurrency']),
        'platformFeePercent': json['platformFeePercent'] == null ? undefined : json['platformFeePercent'],
        'feeStructure': json['feeStructure'] == null ? undefined : CompetitionFeeStructureFromJSON(json['feeStructure']),
        'fuelPricingMode': json['fuelPricingMode'] == null ? undefined : FuelPricingModeFromJSON(json['fuelPricingMode']),
        'minEntryFee': json['minEntryFee'] == null ? undefined : json['minEntryFee'],
        'maxEntryFee': json['maxEntryFee'] == null ? undefined : json['maxEntryFee'],
        'permittedTenders': json['permittedTenders'] == null ? undefined : ((json['permittedTenders'] as Array<any>).map(EntryTenderFromJSON)),
        'tokenEntryConfig': json['tokenEntryConfig'] == null ? undefined : TokenEntryConfigResponseFromJSON(json['tokenEntryConfig']),
    };
}

export function EntryFeeConfigResponseToJSON(json: any): EntryFeeConfigResponse {
    return EntryFeeConfigResponseToJSONTyped(json, false);
}

export function EntryFeeConfigResponseToJSONTyped(value?: EntryFeeConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryFee': value['entryFee'],
        'feeCurrency': EscrowCurrencyToJSON(value['feeCurrency']),
        'platformFeePercent': value['platformFeePercent'],
        'feeStructure': CompetitionFeeStructureToJSON(value['feeStructure']),
        'fuelPricingMode': FuelPricingModeToJSON(value['fuelPricingMode']),
        'minEntryFee': value['minEntryFee'],
        'maxEntryFee': value['maxEntryFee'],
        'permittedTenders': value['permittedTenders'] == null ? undefined : ((value['permittedTenders'] as Array<any>).map(EntryTenderToJSON)),
        'tokenEntryConfig': TokenEntryConfigResponseToJSON(value['tokenEntryConfig']),
    };
}

